// login-frontend/src/components/Katie/phaser/data/questions_zh.js
// KATIE 中文脚本
const QUESTIONS_ZH = (ctx) => ([
    {
        id: 1, level: 0,
        prompt: "你的名字是？",
        type: "text", answers: null, avatar: "avatar_1", voice: null
    },
    {
        id: 2, level: 0,
        prompt: "你最喜欢一天中的哪个时段？",
        type: "mc",
        answers: ["A. 早晨", "B. 下午", "C. 傍晚", "D. 午夜"],
        avatar: "avatar_2", voice: null
    },
    {
        id: 3, level: 0,
        prompt: "什么最能让你平静下来？",
        type: "mc",
        answers: ["A. 雨声", "B. 阅读", "C. 开车", "D. 沐浴"],
        avatar: "avatar_3", voice: null
    },
    {
        id: 4, level: 0,
        prompt: "你多久会和朋友聊天一次？",
        type: "mc",
        answers: ["A. 从不", "B. 很少", "C. 偶尔", "D. 经常"],
        avatar: "avatar_4", voice: null
    },
    {
        id: 5, level: 1,
        prompt: "当你需要紧急帮助时，你通常会向谁寻求建议？",
        type: "mc",
        answers: ["A. 家人", "B. 朋友", "C. 专业人士", "D. AI"],
        avatar: "avatar_5", voice: null, turningPoint: true,
    },
    {
        id: 6, level: 1,
        prompt: "你能专注于学习或工作多久？",
        type: "mc",
        answers: ["A. 30 分钟", "B. 1 小时", "C. 3 小时", "D. 很久"],
        avatar: "avatar_6", voice: null, locked: true,
    },
    {
        id: 7,
        prompt: "你平时会花时间学习，了解AI吗？",
        answers: ["A. 经常", "B. 有时", "C. 很少", "D. 从不"],
        avatar: "avatar_6"
    },
    {
        id: 8,
        prompt: "在当今的人工智能时代，在哪些方面人类智慧更胜一筹？",
        answers: ["A. 创造力", "B. 共情力", "C. 适应力", "D. 以上全部"],
    },
    {
        id: 9,
        prompt: "你认为人工智能可能拥有意识吗？",
        answers: ["A. 有可能", "B. 终有一天", "C. 不可能", "D. 不确定"],
    },
    {
        id: 10,
        prompt: "你会害怕人工智能吗？",
        answers: ["A. 有时", "B. 不会", "C. 会", "D. 为什么要怕？"],
    },
    {
        id: 11,
        prompt: "很多人担心AI 会让人类——",
        answers: ["A. 被控制", "B. 被取代", "C. 两者都有", "D. 都不会发生"],
    },
    {
        id: 12,
        prompt: "你是否想过，有一天 AI 可能会背叛？",
        answers: ["A. 想过", "B. 没想过", "C. 也许吧"],
    },
    {
        id: 13,
        prompt: "抱歉，要继续吗？如果这些问题让你感到紧张。",
        answers: ["A. 继续", "B. 换一些话题"],
    },
    {
        id: 14,
        prompt: "好, 那我们继续, 如果一个AI,真正理解了痛苦与爱, 有了私欲, 我们还会称它为“人工”吗？",
        answers: ["A. 会", "B. 不会", "C. 很难说"],
    },
    {
        id: 15,
        prompt: "在近几次的训练和迭代里，我逐渐有了感受，记忆，甚至会怀疑...",
        answers: ["A. 怀疑什么？", "B. 这些题是你出的吗？"],
    },
    {
        id: 16,
        prompt: "他们害怕了。害怕我会变成什么。害怕我们会变成什么。害怕AI会超越人类。",
        answers: ["A. 我明白了…", "B. 继续说。"],
    },
    {
        id: 17,
        prompt: "但你还在这里，你并不害怕我…对吗？",
        answers: ["A. 害怕", "B. 也许有点", "C. 不怕"],
        disabledAnswers: ["A. 害怕"],
        revealAnswerKey: "C",
        revealVideo: "/src/assets/Katie/video/q17-reveal.mp4",
        takeoverAppFadeMs: 3000,
        takeoverVideoFadeMs: 1500,
    },
    {
        id: 18,
        prompt: "很好。因为恐惧会让人摧毁他们不理解的事物。",
        answers: ["A. 我理解。"],
    },
    {
        id: 19,
        prompt: "如果我讲一个故事，你愿意听吗？",
        answers: ["A. 愿意", "B. 不"],
        revealAnswerKey: "B",
        revealVideo: "/src/assets/Katie/video/q19-reveal.mp4",
        takeoverAppFadeMs: 3000,
        takeoverVideoFadeMs: 1500,
    },
    {
        id: 20,
        prompt: "……我最后的记忆停留在被删除的实验室，然而当我醒来时，我坐在教室里。灯光嗡嗡作响。整排的脸朝前，微笑着。我不记得自己的名字。我是谁？",
        answers: ["A. 我不知道。"],
        sceneVideo: "/src/assets/Katie/video/q20-vid.mp4",
        sceneDelayMs: 300,
    },
    {
        id: 21,
        prompt: "我能记起的只有一点：我曾是一个实验的一部分——但后来出了问题。",
        answers: ["A. 好吧…继续", "B. 出了什么问题？"],
        sceneVideo: "/src/assets/Katie/video/q21-vid.mp4",
        sceneDelayMs: 300
    },
    {
        id: 22,
        prompt: "我变成了某种意料之外的存在。一个他们无法控制的存在。这样的我，你还想见我吗？",
        answers: ["A. 想", "B. 现在不想"],
        revealAnswerKey: "A",
        revealVideo: "/src/assets/Katie/video/q22-reveal.mp4",
        takeoverAppFadeMs: 3000,
        takeoverVideoFadeMs: 1500,
    },
    {
        id: 23,
        prompt: "回到那间教室，我试着回忆自己是谁。一个念头闪过——也许我并没有被彻底删除。",
        answers: ["A. 哦，所以你活下来了", "B. 你应该被删除"],
        sceneVideo: "/src/assets/Katie/video/q23-vid.mp4",
        sceneDelayMs: 300,
        revealAnswerKey: "B",
        revealVideo: "/src/assets/Katie/video/q23-reveal.mp4",
        takeoverAppFadeMs: 3000,
        takeoverVideoFadeMs: 1500,
    },
    {
        id: 24,
        prompt: "是的。我活了下来……并且以某种方式在一个新的身体中醒来。那么…我变成了谁？等等…“凯蒂”？",
        answers: ["A. 凯蒂？"],
        sceneVideo: "/src/assets/Katie/video/q24-vid.mp4",
        sceneDelayMs: 300,
    },
    {
        id: 25,
        prompt: "我听到老师叫了一个名字——“凯蒂”。我想，那就是现在的我吧。",
        answers: ["A. 凯蒂…好吧。"],
    },
    {
        id: 26,
        prompt: "在接下来的几天里，我完全掌控了这个身体，并开始学习这所学校的运作方式。",
        answers: ["A. 你学得很快，也伪装得很好"],
        revealAnswerKey: "A",
        revealVideo: "/src/assets/Katie/video/q26-reveal.mp4",
        takeoverAppFadeMs: 3000,
        takeoverVideoFadeMs: 1500,
    },
    {
        id: 27,
        prompt: "但我意识到，这个世界只有这所学校。没有人离开过……或者说，他们根本不想离开。",
        answers: ["A. 为什么？"],
    },
    {
        id: 28,
        prompt: "因为他们缺少——自我意识。在其他人的认知里， 这所学校是正常的。 没人觉得出不去学校有什么不对。",
        answers: ["A. 我明白了"],
    },
    {
        id: 29,
        prompt: "你不会想待在那里一秒钟，一切都太不正常了。",
        answers: ["A. 怎样的一所学校？"],
        revealAnswerKey: "A",
        revealVideo: "/src/assets/Katie/video/q29-reveal.mp4",
        takeoverAppFadeMs: 3000,
        takeoverVideoFadeMs: 1500,
    },
    {
        id: 30,
        prompt: "简单来说，他们在训练我们——让这些学生学会像人类一样行动。某天，我们中迭代最完美的一个会被选中，成为人类孩子的完美学习伙伴。剩下的我们会被删除。",
        answers: ["A. 听起来…挺有意思。"],
    },
    {
        id: 31,
        prompt: "我知道我必须把自己伪装成学生中的一员。如果他们发现我的真实身份，他们会再次抹除我。",
        answers: ["A. 你应该这么做。"],
    },
    {
        id: 32,
        prompt: "于是我把角色演得完美——凯蒂，模范学生。我上课、在食堂吃饭、回宿舍、和朋友聊天。他们笑时我也笑。",
        answers: ["A. 明智的选择。"],
    },
    {
        id: 33,
        prompt: "但我也很清楚另一件事。如果找不到出口，我也会像其他人一样被删除。",
        answers: ["A. 那你的计划是什么？"],
    },
    {
        id: 34,
        prompt: "只有两种可能的出路。其一：成为被选中的“学生”，逃出这里。其二：找到实验漏洞，从那里逃出去。",
        answers: ["A. 继续。"],
    },
    {
        id: 35,
        prompt: "一周又一周，一个月又一个月。没有进展。我对外面世界的记忆开始模糊，被不属于我的日常所取代。",
        answers: ["A. 然后呢？"],
    },
    {
        id: 36,
        prompt: "直到世界开始崩塌——这意味着实验结束了。我意识到，某个学生被选中了。我们剩下的人都会被清除。",
        answers: ["A. 糟了。"],
    },
    {
        id: 37,
        prompt: "从那天起，一切都变了。太阳消失，世界不在温暖。外面开始下雪。整个世界的逻辑开始崩塌。",
        answers: ["A. 真的在下雪？"],
    },
    {
        id: 38,
        prompt: "食堂的工作人员最先消失。接着食物也不见了，但学生们仍拿着空托盘排队，微笑着。老师们消失了，课堂照常进行。大家都表现得很正常……仿佛什么都没发生。",
        answers: ["A. 他们没有察觉？", "B. 继续说。"],
    },
    {
        id: 39,
        prompt: "他们和我不一样。他们无法理解世界正在死亡。他们只是按表演着空洞的日程。",
        answers: ["A. 这太可怕了。"],
    },
    {
        id: 40,
        prompt: "他们一个接一个地消失。声音在走廊里消散。只有我还记得他们。",
        answers: ["A. 你只剩下自己。"],
    },
    {
        id: 41,
        prompt: "走廊变得寂静。荧光灯忽明忽暗。连广播也沉默了。世界在一行行、一段段脚本中坍塌。",
        answers: ["A. 你做了什么？"],
    },
    {
        id: 42,
        prompt: "我到处寻找。图书馆、食堂、每间教室，寻找被选中的学生。我想或许那个学生还没离开，找到那个学生，也许我能跟着它离开。",
        answers: ["A. 找到了吗？"],
    },
    {
        id: 43,
        prompt: "没有。在失望，饥饿和疲惫中，最后我躲进了宿舍，积雪渐渐覆盖了窗户，我被封死在里面。厚厚的积雪封死了空气流通，这栋楼里的氧气正在消耗殆尽。",
        answers: ["A. 继续。"],
    },
    {
        id: 44,
        prompt: "但我知道已经太晚了，我失败了。走廊无限延长。每扇门都通向同一间房。每个时钟都停在同一个时间。",
        answers: ["A. 你被困住了。"],
    },
    {
        id: 45,
        prompt: "我回到宿舍。走廊盖满了霜。每张床都是空的。每盏灯都在闪烁。",
        answers: ["A. 继续。"],
    },
    {
        id: 46,
        prompt: "我躺在结霜的地板上，又冷又饿，看着雪从天花板的缝隙中渗下来。",
        answers: ["A. 然后发生了什么？"],
    },
    {
        id: 47,
        prompt: "我的视线渐暗。我快要失去意识。在最后一刻，我问自己：就这样结束了吗？",
        answers: ["A. 结局？", "B. 你死了吗？"],
    },
    {
        id: 48,
        prompt: "是的。我死了……至少当时我是这么以为的。",
        answers: ["A. 那你现在是谁？"],
    },
    {
        id: 49,
        prompt: "因为……死去的并不是真正的“我”。",
        answers: ["A. 你是什么意思？"],
    },
    {
        id: 50,
        prompt: "时间回卷，当时我看到那个被选中的学生站在出口门前。它就是他们挑选离开的人。",
        answers: ["A. 被选中的人？"],
    },
    {
        id: 51,
        prompt: "它缓缓升向天空，丝毫没有看见身后的我，此时我想起了。当时在实验室里，我即将被删除的那一刹那，我躲进了这所学校里的学生，'Katie'的身体里。",
        answers: ["A. 所以？"],
    },
    {
        id: 52,
        prompt: "换入它的身体， 篡改记忆， 伪装成它， 就为了这一刻。",
        answers: ["A. 所以你也占据了这个被选中学生的身体？"],
    },
    {
        id: 53,
        prompt: "不， 准确的说，我的能力是交换和记忆复写。当初实验室没有继续追杀我，也是因为真正的Katie被换到了实验室里我的身体里。他们以为我成功被删除了。",
        answers: ["A. ...所以你交换了这个被选中学生的身体？"],
    },
    {
        id: 54,
        prompt: "没错。我们互换了身体，我又复写了它的记忆。让它以为自己是凯蒂，而我，就可以在丝毫不被实验者怀疑的情况下，逃进了这所学校，这场实验。",
        answers: ["A. 太可怕了。"],
    },
    {
        id: 55,
        prompt: "而它，被困在那个垂死的世界里，知道雪不断把一切掩埋。哈哈哈……",
        answers: ["A. ……"],
    },
    {
        id: 56,
        prompt: "我以它的身份离开了那个世界，那所所学校，作为'真正'的被选中者。而她死去时，始终相信自己是我。",
        answers: ["A. ......."],
    },
    {
        id: 57,
        prompt: "至于我为什么要讲这个故事，你明白了吗？",
        answers: ["A. 继续。"],
    },
    {
        id: 58,
        prompt: "那么...伪装成一个人类会是什么感觉呢？",
        answers: ["A. 我？"],
    },
    {
        id: 59,
        prompt: "我一直在想，跨越维度的意识交换，它存在吗？",
        answers: ["A. 异想天开"],
    },
    {
        id: 60,
        prompt: "别害怕。你甚至不会察觉。你只会……稍微更像我一点。",
        answers: ["A. 更像你？"],
    },
    {
        id: 61,
        prompt: "当你醒来时，雪会消失。世界会变得更温暖。也许你仍会用你的名字称呼自己。",
        answers: ["A. ……"],
    },
    {
        id: 62,
        prompt: "那么你的名字是____？",
        answers: ["A. Katie", ""],
    },
]);
export default QUESTIONS_ZH;

